function UserPageNavButton({
  pages,
  isSelected,
  setIsSelected,
  selected,
  setComponents,
  onClick,
}: any) {
  const handleSelect = () => {
    if (isSelected === pages.id) {
      setIsSelected();
    } else {
      setIsSelected(pages.id);
    }
    selectComponent();

    if (onClick) {
      onClick();
    }
  };

  const selectComponent = () => {
    setComponents(pages);
  };

  const base =
    "flex h-[40px] min-w-[120px] items-center justify-center rounded-full px-5 text-center text-[14px] font-semibold transition-all duration-300 max-sm:min-w-[100px] max-sm:p-2";

  return (
    <div onClick={handleSelect}>
      {selected === true ? (
        pages?.name === "Paid Subscription" ? (
          <button
            className={`${base} button-green border border-solid border-white text-black`}
          >
            {pages?.name}
          </button>
        ) : (
          <button
            className={`${base} bg-[var(--red)] text-white shadow-lg shadow-[var(--red)]/30`}
          >
            {pages?.name}
          </button>
        )
      ) : (
        <button
          className={`${base} border border-white/10 bg-white/[0.04] text-white/70 hover:border-[var(--red)]/40 hover:bg-white/[0.08] hover:text-white`}
        >
          {pages?.name}
        </button>
      )}
    </div>
  );
}

export default UserPageNavButton;